module.exports = __webpack_public_path__ + "img/type25.c1a38e5a.png";